import * as apiHelper from './../helpers/apiHelper';
import * as loadingActions from './loadingActions';

export var submitSurvey = (question, answer) => {
	return (dispatch, getState) => {
		const url = "dashboard/survey";
      const formData = { question, answer };

      return apiHelper.apiRequest(url, 'post', formData, dispatch, getState).then(res => {
         dispatch(loadingActions.removeLoading());
         return res.ok;
      });
	};
};

export var closeSurvey = () => {
	return (dispatch, getState) => {
		const url = "dashboard/survey";

      return apiHelper.apiRequest(url, 'delete', null, dispatch, getState).then(res => {
         dispatch(loadingActions.removeLoading());
         return res.ok;
      });
	};
};


// WEBPACK FOOTER //
// ./src/actions/userActions.js